import { ContentState, convertFromRaw } from "draft-js";
import React from "react";
import styled, { CSSProperties } from "styled-components";
import { TextSection } from "@domain/lms/article/article";
import { DraftRenderer } from "@ui/components/containers/draftRenderer";

interface TextSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: TextSection;
	style?: CSSProperties;
	isFold?: boolean;
}
export const TextSectionView: React.FC<TextSectionViewProps> = ({ section, isFold = false, style, ...htmlProps }) => {
	let content: ContentState;
	if (typeof section.content === "string") content = convertFromRaw(JSON.parse(section.content));
	else content = section.content;
	return (
		<Container style={style} {...htmlProps}>
			<DraftRenderer fold={isFold} content={content} />
		</Container>
	);
};

const Container = styled.div`
	padding-left: 40px;
	@media (max-width: 900px) {
		font-size: 17px;
		line-height: 34px;
		padding-left: 15px;
		padding-right: 15px;
	}
	${({ theme }) => theme.textStyles.primary};
	font-family: Sora;
	font-style: normal;
	font-weight: normal;
	font-size: 19px;
	line-height: 40px;
`;
